<groundworks-card [title]="'Attachments'" [isCollapsible]="true">
  <groundworks-card-body>
    <div class="attachments-section">
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab() === 'documents'" (click)="selectTab('documents')">
            Documents ({{ documentsCount() }})
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab() === 'pictures'" (click)="selectTab('pictures')">
            Pictures {{ picturesCount() }}/25
          </button>
        </li>
      </ul>

      @switch (state()) {
        @case ('loading') {
          <groundworks-state-message type="loading" message="Loading Attachments..." class="d-flex" />
        }
        @case ('no-matches') {
          <groundworks-state-message type="no-matches" message="No Attachments Found." class="d-flex" />
        }
        @case ('error') {
          <groundworks-state-message type="error" message="Error loading attachments." class="d-flex" />
        }
        @case ('matches') {
          @if (totalPages() > 1) {
            <div class="d-flex align-items-center justify-content-between mb-3">
              <span class="text-muted small" data-testid="attachments-range">{{ rangeLabel() }}</span>
              <groundworks-pagination [currentPage]="effectivePage()" [totalPages]="totalPages()"
                [maxVisiblePages]="5" [showEllipsis]="true" (pageChange)="onPageChange($event)" />
            </div>
          }
          <div #attachmentsScroll class="overflow-auto mb-3" style="max-height: 650px" data-testid="attachments-scroll">
            <div class="d-flex flex-row flex-wrap gap-3">
              @for (attachment of pagedItems(); track attachment.id) {
                <groundworks-image-tile [tile]="toTileData(attachment)" (tileClick)="onTileClick($event)" />
              }
            </div>
          </div>
        }
      }
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" (click)="onAddAttachment()">Upload File</button>
      </div>
    </div>
  </groundworks-card-body>
</groundworks-card>
